import DataComponent from "../../testCommon/DataComponent";

const AnalyzedData = ({ testResults, testInfo }: any) => {
  return (
    <div>
      {testResults?.length > 0
        ? testResults?.map((dataItem: any, idx: number) => (
            <DataComponent
              key={idx}
              data={dataItem}
              gender={testInfo.gender}
              birthDay={testInfo.birth_day}
              defaultChecked={dataItem.status !== "N"}
            />
          ))
        : ""}
    </div>
  );
};

export default AnalyzedData;
